<template>
  <div>
    <section class="page-title text-center mb-5">
      <div class="container">
        <div class="content-box">
          <h1>
            {{ $t("myreservations") }}
          </h1>
        </div>
      </div>
    </section>
    <div style="background-color: white; padding-top: 36px; padding-bottom: 150px">
      <div class="container">
        <!-- Desktop Table View -->
        <div class="d-none d-lg-block">
          <!-- Loading State -->
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2 text-muted">{{ $t('Loading reservations...') }}</p>
          </div>

          <!-- Empty State -->
          <div v-else-if="list.length === 0" class="text-center py-5">
            <i class="fa fa-calendar-times fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">{{ $t('No reservations found') }}</h5>
            <p class="text-muted">{{ $t('You don\'t have any reservations yet.') }}</p>
          </div>

          <!-- Table -->
          <table v-else class="table table-bordered table-responsive">
            <thead>
              <tr>
                <th scope="col" style="width:100px">#</th>
                <!-- <th scope="col">{{ $t('First Name') }}</th>
                <th scope="col">{{ $t('Last Name') }}</th> -->
                <!-- <th scope="col">{{ $t('Massage') }}</th> -->
                <th scope="col">{{ $t('Plan') }}</th>
                <th scope="col">{{ $t('Day') }}</th>
                <th scope="col">{{ $t('Time') }}</th>
                <th scope="col">{{ $t('Masser') }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item of list" :key="item.id">
                <th scope="row">{{ $codePadding(item.id) }}</th>
                <!-- <td>{{ item.fname }}</td>
                <td>{{ item.lname }}</td> -->
                <!-- <td>{{ $getByLang(item.massageId.name) }}</td> -->
                <td>{{ $getByLang(item.pricesId.name) }} ({{ item.pricesId.price }} €)</td>
                <td>{{ $durationFormat(item.start) }}</td>
                <td>{{ $durationFormatStartToEnd(item.start, item.end) }}</td>
                <td>{{ item.adminsId.fullName }}</td>
                <td class="text-center">
                  <router-link :to="'onereservations/' + item.id" class="btn btn-sm btn-outline-primary">
                    <i class="fa fa-eye"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile Card View -->
        <div class="d-lg-none">
          <!-- Loading State -->
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2 text-muted">{{ $t('Loading reservations...') }}</p>
          </div>

          <!-- Empty State -->
          <div v-else-if="list.length === 0" class="text-center py-5">
            <i class="fa fa-calendar-times fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">{{ $t('No reservations found') }}</h5>
            <p class="text-muted">{{ $t('You don\'t have any reservations yet.') }}</p>
          </div>

          <!-- Reservations List -->
          <div v-else>
            <div v-for="item of list" :key="item.id" class="reservation-card mb-3">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">#{{ $codePadding(item.id) }}</h6>
                  <router-link :to="'onereservations/' + item.id" class="btn btn-sm btn-outline-primary">
                    <i class="fa fa-eye"></i>
                  </router-link>
                </div>
                <div class="card-body container">
                  <div class="row">
                    <!-- <div class="col-6 mb-2">
                      <strong>{{ $t('First Name') }}:</strong>
                      <div>{{ item.fname }}</div>
                    </div>
                    <div class="col-6 mb-2">
                      <strong>{{ $t('Last Name') }}:</strong>
                      <div>{{ item.lname }}</div>
                    </div> -->
                    <!-- <div class="col-12 mb-2">
                      <strong>{{ $t('Massage') }}:</strong>
                      <div>{{ $getByLang(item.massageId.name) }}</div>
                    </div> -->
                    <div class="col-12 mb-2">
                      <strong>{{ $t('Plan') }}:</strong>
                      <div>{{ $getByLang(item.pricesId.name) }} ({{ item.pricesId.price }} €)</div>
                    </div>
                    <div class="col-6 mb-2">
                      <strong>{{ $t('Day') }}:</strong>
                      <div>{{ $durationFormat(item.start) }}</div>
                    </div>
                    <div class="col-6 mb-2">
                      <strong>{{ $t('Time') }}:</strong>
                      <div>{{ $durationFormatStartToEnd(item.start, item.end) }}</div>
                    </div>
                    <div class="col-12 mb-2">
                      <strong>{{ $t('Masser') }}:</strong>
                      <div>{{ item.adminsId.fullName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      loading: true,
    };
  },

  methods: {
    async loadReservations() {
      try {
        this.loading = true;
        const user = JSON.parse(localStorage.userKB);
        
        const response = await this.$http.post("appointments/myappointments?usersId=" + user.id, {});
        this.list = response.data.data || [];
      } catch (error) {
        console.error('Error loading reservations:', error);
        this.list = [];
      } finally {
        this.loading = false;
      }
    }
  },
  
  async created() {
    await this.loadReservations();
  },
};
</script>

<style scoped>
/* Mobile Card Styles */
.reservation-card .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: box-shadow 0.3s ease;
}

.reservation-card .card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.reservation-card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 12px 16px;
}

.reservation-card .card-body {
  padding: 16px;
}

.reservation-card .card-body .row > div {
  padding: 4px 8px;
}

.reservation-card .card-body strong {
  color: #495057;
  font-size: 0.9rem;
  display: block;
  margin-bottom: 2px;
}

.reservation-card .card-body div {
  color: #6c757d;
  font-size: 0.85rem;
  word-break: break-word;
}

/* Desktop Table Improvements */
.table-responsive {
  border-radius: 8px;
  overflow: hidden;
}

.table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

/* Button Improvements */
.btn-outline-primary {
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8rem;
}

.btn-outline-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,123,255,0.3);
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .reservation-card .card-body .row > div {
    padding: 2px 4px;
  }
  
  .reservation-card .card-body strong {
    font-size: 0.8rem;
  }
  
  .reservation-card .card-body div {
    font-size: 0.8rem;
  }
  
  .reservation-card .card-header {
    padding: 8px 12px;
  }
  
  .reservation-card .card-body {
    padding: 12px;
  }
}

/* Empty state styling */
.reservation-card:empty {
  display: none;
}

/* Loading state */
.reservation-card.loading {
  opacity: 0.6;
  pointer-events: none;
}
</style>
